import { useCallback } from 'react';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';
 
import {
  where,
  getCountFromServer,
  query,
  collection,
  CollectionReference,
} from 'firebase/firestore';
import { User } from '../firebase/entities';

type WithId<T> = T & { id: string };
 
const useFetchUsersAll = () => {
  const firestore = useFirestore();
  const userCollection = 'users';
  
  return useFirestoreCollectionData(query(
    collection(firestore, userCollection) as CollectionReference<WithId<User[]>>
  ), {
    idField: 'id',
  });
}
 
export default useFetchUsersAll;